import React from 'react';
import { faPennant } from '@fortawesome/pro-solid-svg-icons/faPennant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PennantSolidIcon(props) {
  return <FontAwesomeIcon icon={faPennant} {...props} />;
}
